// extracted by mini-css-extract-plugin
export default {"content":"AddFlashCard_content__ozy3I","flashcard-list":"AddFlashCard_flashcard-list__w6w1C"};